// ** React Imports
import { useCallback } from "react";

// ** Custom Components
import Block from "components/layout/Block";

// ** Location Chips Components
import LocationsListingLink from "./components/LocationsListingLink";
import LocationLink from "./components/LocationLink";

// ** Utils & Helpers
import generatePath from "utils/generatePath";

// ** Styled Components
import { StyledArrow } from "components/other/styles";

// #####################################################

const LocationChipsCountryWithoutRegionsLevel = ({
	country = {},
	path,
	queryString,
}) => {
	// ** Funkcja Renderująca Link Do Wybranego Kraju
	const renderCountryLink = useCallback(() => {
		const generatedPath = generatePath(path, {
			country: country?.url,
		});
		if (country?.url) {
			return (
				<>
					{/* Strzałka */}
					<StyledArrow />
					<LocationLink
						name={country?.name}
						to={generatedPath}
						query={queryString}
						isLast
						isBold
					/>
				</>
			);
		}
		return null;
	}, [country?.url, queryString]);

	// #####################################################

	return (
		<Block flex flexWrap>
			{/* Link 'Użytkownikcy / Lokalizacje */}
			<LocationsListingLink path={path} queryString={queryString} />

			{/* Link do wybranego kraju */}
			{renderCountryLink()}
		</Block>
	);
};

// #####################################################

export default LocationChipsCountryWithoutRegionsLevel;

// #####################################################
